/* eslint-disable no-console, no-undef, function-paren-newline */
const stringToHash = (str) => {
  const url = `${window.facebookApiUrl}hash`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      body: str,
      headers: {
        'content-type': 'text/plain',
      },
      method: 'POST',
    })
      .then((response) => {
        if (response.ok) {
          response.text().then(resolve);
        } else {
          response.text().then(reject);
        }
      })
      .catch(console.error);
  });
};

const convertLead = (options) => {
  const {
    eventName,
    userDataHashed,
  } = options;
  // Deduping id (must be UNIX timestamp in GMT/UTC)
  const eventId = Math.floor(new Date(new Date().toUTCString()).getTime() / 1000);
  // Existing pixel code
  if (pintrk && userDataHashed) {
    userDataHashed.event_id = eventId;
    pintrk('track', eventName, userDataHashed);
  }
  // Conversion API
  const json = JSON.stringify({
    data: [
      {
        action_source: 'web',
        advertiser_id: 549756471414,
        event_name: eventName,
        event_id: eventId.toString(),
        event_source_url: window.location.href,
        event_time: eventId,
        user_data: userDataHashed,
      },
    ],
  });
  const url = `/api/service/pinterestconversionsapi?json=${json}`;
  fetch(url, {
    headers: {
      'content-type': 'text/plain',
    },
    method: 'POST',
  })
    /* .then((response) => {
      if (response.ok) {
        response.json().then((data) => {
          console.log(data);
        });
      } else {
        response.json().then((data) => {
          console.log(data);
        });
      }
    }) */
    .catch(console.error);
};

const encodeUserData = (options) => {
  const { userData } = options;
  // Loop through object
  const promises = [];
  options.userDataHashed = {};
  Object.keys(userData).forEach((key) => {
    promises.push(
      stringToHash(userData[key])
        .then((hash) => {
          if (hash) {
            options.userDataHashed[key] = [hash.replace(/"/g, '')];
          }
        })
        .catch((error) => {
          console.log(error);
        }),
    );
  });
  Promise.all(promises)
    .then(() => {
      convertLead(options);
    });
};

const ctPinterestApi = (eventName, userData) => {
  const options = {
    eventName,
    userData,
  };
  if (userData) {
    // Hash userData
    encodeUserData(options);
  } else {
    convertLead(options);
  }
};

window.ctPinterestApi = ctPinterestApi;

export default ctPinterestApi;
/* eslint-disable no-console, no-undef, function-paren-newline */
